import { Component, Injector, OnInit } from '@angular/core';
import { debounceTime, filter, first } from 'rxjs/operators';

import {
  CustomerAvailableDocuments,
  DocumentType,
  StepData
} from 'models';

import { SimTypeEnum } from '../../../../../../app-shared/models/steps/step-sim.interface';
import { ProcessStepBaseComponent } from '../../_core/process-step-base.component';

@Component({
  selector: 'sb-step-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent extends ProcessStepBaseComponent implements OnInit {
  public documentTypes: DocumentType[] = [];
  public isESim: boolean;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    // super.shouldShowBackButton();
    super.isStickyNavigation();
    super.setFormGroup(this.formsService.generateStepDocumentForm());
    super.setFormStoreDataFunction(this.appStoreFacadeService.step.storeStepDocumentValue);
    this.getFormDataAndValidation();
  }

  private getFormDataAndValidation() {
    this.subscriptions.add(
      this.appStoreFacadeService.entity.customerAvailableDocuments$
        .pipe(first(Boolean))
        .subscribe(({ documents }: CustomerAvailableDocuments) => {
          this.documentTypes = documents.map(id => ({ id, name: `ENTITY.DOCUMENT-TYPE.${id.toUpperCase()}` }));
          this.translateConstants();
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.document$
        .subscribe((stepData: StepData) => {
          super.setFormGroupStepData(stepData);
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.documentValue$
        .pipe(debounceTime(150), first(Boolean))
        .subscribe(() => {
          this.sendAnalyticsData();
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.entity.simType$
        .pipe(first(Boolean))
        .subscribe(({ value }) => {
          const simType = value && value.type;
          this.isESim = simType === SimTypeEnum.eSim;
        })
    );

    const documentType = this.formGroup.get('customerDocument.type');
    const documentNumber = this.formGroup.get('customerDocument.number');
    const documentDate = this.formGroup.get('customerDocument.issueDate');

    this.subscriptions.add(
      documentType.valueChanges
        .pipe(
          filter(Boolean)
        )
        .subscribe(() => {
          documentDate.updateValueAndValidity();
          documentNumber.updateValueAndValidity();
        })
    );
  }

  private translateConstants() {
    this.translateService
      .get(this.documentTypes[0].id)
      .subscribe(() => {
        this.documentTypes = this.documentTypes.map(type => {
          type.name = this.translateService.instant(type.name);
          return type;
        });
      });
  }
}
